import React from 'react';
import { Tab, Tooltip } from '@chakra-ui/react';
import { Icon } from "@chakra-ui/icons";
import { MdHome } from 'react-icons/md';

const HomeTab = () => {

    return (
        <Tooltip label="Home" aria-label="Home">
            <Tab sx={{ color: '#73d6c2', _selected: { bg: 'green.100' } }}>
                <Icon as={MdHome} boxSize={8} />
            </Tab>
        </Tooltip>
    );
};

export default HomeTab;